import Vue from 'vue';
import AnimateCSS from 'animate.css'

Vue.use(AnimateCSS)